import { get } from "lodash";
import React from "react";
import styled from "styled-components";

import { checkRole, sortDesignPosition } from "../../../helper";
import { CompareDesignTabsPolaris } from "../actions/CompareDesignTabsPolaris";
import { ACCS_HAVE_COLOR_PICKER } from "../../../variable";
import { useAppContext } from "../../../context";

function TableDataNeedReviewDesign({ node }) {
    const designs = getDesigns(node);

    const { currentUser } = useAppContext();

    const { isSeller, isDesignLeader, isStoreManager, isMarketplaceManager } =
        checkRole(currentUser);

    const userId = currentUser?.id;
    const userSpecial = ACCS_HAVE_COLOR_PICKER.includes(userId);

    const isDLead =
        isSeller ||
        isDesignLeader ||
        isStoreManager ||
        isMarketplaceManager ||
        !!userSpecial;

    const { orderId, requirement } = node || {};

    return (
        <Wrapper>
            <CompareDesignTabsPolaris
                designs={designs}
                orderId={orderId}
                taskRequirement={requirement}
                isDLead={isDLead}
            />
        </Wrapper>
    );
}

function getDesigns(node) {
    let designs = get(node, "taskSubmission.designs") || [];
    return sortDesignPosition(designs);
}

const Wrapper = styled.div`
    width: 600px;
    position: relative;

    .modal-image-item {
        flex-direction: column;
        align-items: start !important;

        .modal-image-info {
            padding-left: 1rem;
        }
    }

    .color-picker-wrap {
        position: absolute;
        top: 8rem;
        right: unset;
        left: calc(100% + 1rem);
    }
`;

export default TableDataNeedReviewDesign;
